<template>
    <!-- 以下Footer  -->
    <div class="container-fluid mt-5" style="position: fixed; z-index: 1;bottom: 0;">
        <div class="footer1">{{ $t("system.contactUnit") }}<a href="mailto:VIP_ADMIN@compal.com">VIP_ADMIN@compal.com</a>{{ $t("system.contactUs") }} | <a href="#exampleModal" data-bs-toggle="modal"
                class="wlink">Supplier Opinion</a></div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="background-color: #9bb956;">
                    <h1 class="modal-title fs-5 text-white" id="exampleModalLabel">Supplier Opinion</h1>
                </div>
                <div class="modal-body">
                    <span style="color: #748c3c;">
                        本公司為落實企業社會責任，遵守RBA
                        相關規範，維護供應商之應有權益，並促進雙方良好的合作關係，特設立此供應商溝通管道，由稽核單位專人處理。若本公司員工有索賄、威脅及其他不當行為時，歡迎您向我們的溝通窗口提出： <a
                            href="mailto:ethics@compal.com">ethics@compal.com</a>。本公司對於舉發者和參與調查者將給予保護，以避免其遭受報復或不公平對待，並確保其身份的機密性。
                        <p></p></span>
                    <span style="color: #878786;">
                        In order to fulfill Corporate Social Responsibility, comply with RBA protocol and protect the
                        rights of our suppliers to promote the cooperation between both sides. We set a communication
                        channel for our suppliers and arrange a specialist from the Audit Office to deal with it. If
                        Compal’s employees ask for bribes, threaten or do other misconducts, please contact us via <a
                            href="mailto:ethics@compal.com">ethics@compal.com</a>. We
                        absolutely protect identity of the reporter or the participants who are in investigation and
                        keep them from unfair retaliation or treatment.</span>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'VIPFooter',
    
   

}
</script>
<style scoped>

.footer1 {
    width: 100vw;
    height: 40px;
    color: #FFF;
    background-color: #9bb956;
    z-index: 1;
    bottom: 0;
    position: fixed;
    line-height: 40px;
    text-align: center;
    margin-left: -12px;
}
</style>
  
 
  